<app-internal-header ></app-internal-header>
 
<section class="bg-page-container"><!--container-->
    <div class="p-2 p-lg-5 pt-md-4 mb-3 h-100">
        <router-outlet></router-outlet>
    </div>
</section>
